/**
 * 再生方式の設定。端末ごとにローカルへ保存する。
 *
 * 'audio'  … サーバが中継する音声を `<audio>` で鳴らす。画面を消しても
 *            別のアプリを開いても鳴り続ける。映像は出ない。
 * 'iframe' … YouTube の埋め込みプレイヤー。映像も出るが、スマホでは
 *            画面を消すと止まる。
 *
 * どちらが良いかは使い方次第なので、利用者に選ばせる。
 */
export type PlaybackMode = 'audio' | 'iframe';

const KEY = 'jam:playbackMode';

export const PLAYBACK_MODE_LABEL: Record<PlaybackMode, string> = {
  audio: 'バックグラウンド再生',
  iframe: '動画で再生',
};

export const PLAYBACK_MODE_DESCRIPTION: Record<PlaybackMode, string> = {
  audio: '画面を消しても、別のアプリを開いても鳴り続けます。映像は出ません。',
  iframe: '映像も一緒に出ます。スマホで画面を消すと止まります。',
};

export function loadPlaybackMode(): PlaybackMode {
  try {
    return localStorage.getItem(KEY) === 'iframe' ? 'iframe' : 'audio';
  } catch {
    return 'audio';
  }
}

export function savePlaybackMode(mode: PlaybackMode): void {
  try {
    localStorage.setItem(KEY, mode);
  } catch {
    // プライベートモードなどで保存できなくても、その場の選択は効く
  }
}
